/* eslint-disable max-lines */
/* eslint-disable sort-keys */
/* eslint-disable max-len */
import { NAME_MAX_LENGTH, PASSWORD_MIN_LENGTH, PASSWORD_MAX_LENGTH, NAME_MIN_LENGTH } from '../../constants/validator'

export const UZ = {
  app: {
    confirmEmail: {
      title: 'Elektron pochta manzilini tasdiqlab bo‘lmadi',
      description: 'Siz allaqachon elektron pochta manzilingizni tasdiqlagansiz yoki xatolik yuz berdi',
      description2:
        'Tasdiqlash havolasini keyinroq qaytadan ochib koʻring yoki 998 78 150 40 84 raqami orqali qoʻllab-quvvatlash jamoamiz bilan bogʻlaning',
      phone: '998 78 150 40 84',
    },
    updateEmail: {
      success: {
        title: 'Elektron pochta manzili muvaffaqiyatli yangilandi',
      },
      error: {
        title: 'Elektron pochta manzilini yangilab bo‘lmadi',
        description: 'Siz allaqachon elektron pochta manzilingizni tasdiqlagansiz yoki xatolik yuz berdi',
        phone: '998 78 150 40 84',
      },
    },
    errors: {
      'A previous email sent less than a minute ago': 'Xat bir daqiqa avval yuborildi, iltimos, kuting',
      'The previous active code was generated less than a minute ago':
        'Kod bir daqiqadan kamroq vaqt oldin yaratilgan, iltimos,kuting',
      'A previous sms code sent less than a minute ago':
        'Kod bir daqiqadan kamroq vaqt oldin yaratilgan, iltimos,kuting',
      'A previous call less than a minute ago': 'Kod bir daqiqadan kamroq vaqt oldin yaratilgan, iltimos,kuting',
      'Invalid verification sms code entered': 'Yaroqsiz SMS tasdiqlash kodi kiritildi',
      'Try after 30 seconds': "30 soniyadan keyin qayta urinib ko'ring",
      'Try after 1 hour': "So'rovlar limiti tugadi, 1 soatdan keyin takror urinib ko'ring",
      invalidDate: {
        message: 'Sana notoʼgʼri qiymatga ega',
      },
      // Albatta kiriting: 6 ta belgi, bitta bosh va bir kichik xarf va bitta raqamni albatta kiriting. Lotin imlosi, raqamlar va .@/ belgilardan bushliqlar qoldirmagan xolda foydalanish mumkin.
      // Albatta 6 tadan 20 tagacha belgi, bitta katta harf, bitta kichkina harf va bitta raqam bo‘lsin. Lotin harflari, raqamlari, oraliq, .@ - belgilaridan foydalanish mumkin.
      passwordError: {
        necessarilyUse: 'Albatta',
        minAndMaxLength: `${PASSWORD_MIN_LENGTH} tadan ${PASSWORD_MAX_LENGTH} tagacha belgi`,
        minLength: `${PASSWORD_MIN_LENGTH} ta belgi`,
        withoutSpaces: 'bushliqlar',
        withUpperCase: 'bitta katta harf',
        withLowerCase: 'bitta kichkina harf',
        and: 'va',
        may: 'foydalanish mumkin.',
        useLatinLetter: 'Lotin harflari',
        letters: 'raqamlari, oraliq',
        withNumber: 'bitta raqam bo‘lsin',
        signs: '.@- belgilaridan',
      },
    },
    footer: {
      contacts: {
        digital: {
          title: 'Телефон службы подписки:',
        },
        periodic: {
          title: 'Телефон службы сервиса:',
        },
      },
      copyright: 'ООО «Издательский дом МЦФЭР-У»',
      uzCopyright: '«MСFR-U Nashriyot uyi» MChJ',
    },
    logon: {
      authorization: {
        buttonText: 'Kirish',
        concatenationText: 'yoki',
        continue: 'Davom etish',
      },
      registration: {
        createAccount: 'Akkaunt yaratish',
      },
      companyDescription: 'Группа и сеть профессиональных сайтов',
      login: {
        errors: {
          incorrectEmailOrPhone: {
            message: "Pochta yoki telefon formati noto'g'ri",
          },
          valueIsRequired: {
            message: 'Elektron pochtani yoki telefon raqam kiriting',
          },
        },
        label: 'Elektron pochta yoki telefon raqam',
        loginWith: 'Yordamida kirish',
        resend: 'Qayta yuborish',
        confirmEmail: 'Pochta tasdiqlanmadi. Roʻyxatdan oʻtishni yakunlash uchun elektron pochtadagi havolaga oʻting',
      },
      password: {
        errors: {
          valueIsRequired: {
            message: 'Parolni kiritin',
          },
          wrongPassword: "Noto'g'ri Login yoki parol.",
        },
        label: 'Parol',
        reset: {
          successText: 'Xat pochta yuborildi, pochtangizni tekshiring',
          successPhoneText: 'Sizga kod SMS orqali yuborildi',
          forgotPassword: 'Parolni eslay olmayman',
        },
      },
      phoneCode: {
        errors: {
          incorrectValue: {
            message: 'SMS dagi kod xato kiritilgan',
          },
          valueIsRequired: {
            message: 'SMS dagi kodi kiritilmagan',
          },
        },
        label: 'SMS-dagi kod',
      },
      title: 'Mahsulotlarga kiring',
    },
    changePassword: {
      title: "Parolni o'zgartirish",
      submitButton: 'Saqlash va tizimga kiring',
      description:
        'Minimal uzunlik - 6 ta belgi. Bitta katta harf, bir kichik harf va bir raqamdan albatta foydalaning',
      password: {
        label: 'Yangi parol',
        generatePasswordButton: 'Mos keladigan parolni yarating',
      },
      invalidCode: 'Parolni tiklash uchun havola muddati tugagan, parolni qayta tiklashni qayta so‘rang',
      successChanged: "parol muvaffaqiyatli o'zgartirildi",
      successLogin: 'Saytga kirish amalga oshmoqda',
    },
    authFromSocial: {
      error: {
        title: 'Xatolik yuz berdi',
        notEmailDescription: "Sizning elektron pochta manzilingizni ijtimoiy tarmoqdan olishni imkoni bo'lmadi.",
        description:
          'Server xatosi. Hozircha tizimga kirishni imkoni yo‘q. Bir necha daqiqadan so‘ng qayta urinib ko‘ring.',
        firstPartText: "Ro'yxatdan o'tishni yakunlash uchun saytimizdagi",
        linkText: " namunani to'ldiring",
        lastPartText: '.',
      },
    },
    registration: {
      form: {
        title: 'Yangi akkaunt yaratish',
      },
    },
    shortForm: {
      form: {
        title: {
          phone: 'Telefon raqamingizni kiriting',
          staff: "Kompaniyangiz hajmini ko'rsating",
          taxation: "Soliq solish tizimingizni ko'rsating",
          position: 'Oʼz lavozimingizni koʼrsating',
          postAndPhone: 'Professional axborotni olish uchun bepul ikkita oddiy qadam',
          organization: 'Oʼz kompaniyangiz nomini koʼrsating',
          birthDate: 'Tug‘ilgan kun sanasini kiriting',
          branch: 'Oʼzingizning faoliyatingiz sohasini koʼrsating',
        },
        submit: {
          finishRegistration: 'Registratsiyani yakunlash',
          position: 'Oʼz lavozimingizni koʼrsating',
          phone: 'Telefon raqamingizni kiriting',
          saveChanges: 'Oʼzgarishlarni saqlash',
        },
        postAndFormShortuserAgreements: {
          firstText: '"Registratsiyani yakunlash" tugmasini bosish bilan',
          conditionalTitle: 'foydalanuvchi kelishuvi',
          secondText: 'shartlarini qabul qilasiz.',
        },
        userAgreements: {
          text: 'Maʼlumotlarni saqlagancha, siz',
          link: 'foydalanuvchilar bitimini',
          additionalText: 'qabul qilgan boʼlasiz',
        },
      },
    },
    formComponents: {
      authorization: {
        buttonText: 'Kirish',
      },
      form: {
        title: 'Yangi akkaunt yaratish',
        firstName: {
          name: 'Ism',
          validation: {
            required: 'Ismingizni albatta yozing',
            allowedSymbols: 'Kiril, lotin imlolari va chiziqdan foydalanish mumkin',
            minLength: `Ismingizni albatta yozing. Eng kamida  - ${NAME_MIN_LENGTH} ta belgi`,
            maxLength: `Ismi ${NAME_MAX_LENGTH} ta belgidan oshmasligi kerak`,
          },
        },
        middleName: {
          name: 'Otasini ismi',
          validation: {
            required: 'Sharifingizni albatta yozing',
            allowedSymbols: 'Kiril, lotin imlolari va chiziqdan foydalanish mumkin',
            minLength: `Sharifingizni albatta yozing. Eng kamida  - ${NAME_MIN_LENGTH} ta belgi`,
            maxLength: `Otasini ismi ${NAME_MAX_LENGTH} ta belgidan oshmasligi kerak`,
          },
        },
        lastName: {
          name: 'Familiya',
          validation: {
            required: 'Familiyangizni albatta yozing',
            allowedSymbols: 'Kiril, lotin imlolari va chiziqdan foydalanish mumkin',
            minLength: `Familiyangizni albatta yozing. Eng kamida  - ${NAME_MIN_LENGTH} ta belgi`,
            maxLength: `Familiya ${NAME_MAX_LENGTH} ta belgidan oshmasligi kerak`,
          },
        },
        email: {
          name: 'Pochta',
          description: 'ro‘yxatga olishni tasdiqlash uchun havola yuboramiz',
          validation: {
            required: 'Pochtasiz sizni ro‘yxatdan o‘tkaza olmaymiz',
            emailFormat: "Noto'g‘ri pochta shakli. Misol: name@domain.uz",
            emailTemp: 'Bir martali pochtadan ro’yxatdan o’tish man etilgan',
            maxLength: "Noma'lum pochta",
            alreadyExists: {
              text: 'Ushbu pochta avval ro‘yxatdan o‘tgan.',
              linkToLogon: 'Tizimga kiring',
              concatenationText: 'yoki',
              linkToRestorePassword: 'parolni tiklang',
            },
          },
        },
        password: {
          name: 'Parol',
          placeholder: 'Parol o‘ylab toping',
          validation: {
            required: "Parol' o‘ylab toping. Eng kamida — 6 ta belgi",
            requiredSymbols:
              'Eng kamida - 6 ta belgi.Bitta katta harf, bir kichik harf va bitta raqamdan albatta foydalaning',
            allowedSymbols: 'Lotin harflari, sanalari va ramzlarni .@- qo‘llash mumkin. Eng kamida — 6 ta belgi',
            minLength: 'Eng kamida — 6 ta belgi',
            maxLength: `Parol ${PASSWORD_MAX_LENGTH} ta belgidan oshmasligi kerak`,
          },
        },
        phone: {
          name: 'Telefon',
          description: 'parolni unutganda kerak bo‘ladi',
          validation: {
            required: 'Telefon raqamini yozing. Misol: +998 99 888 7766',
            phoneFormat: 'Telefon raqamining noto‘g‘ri shakli. Misol: +998 99 888-77-66',
            alreadyExists: {
              text: 'Ushbu raqam avval ro‘yxatdan o‘tgan.',
            },
          },
        },
        sendCode: {
          verifyWithCode: 'Kod orqali tasdiqlash',
          getCodeAgain: 'Kodni qayta so‘rash:',
          button: {
            smsText: 'SMS yuboring',
            codeCall: "Kodli qo'ng'iroqni qabul qiling",
            divider: 'yoki',
            callText: 'Qayta qo‘ng‘iroq qiling',
            timeoutText: 'Dan so‘ng qayta yuborish',
          },
          input: {
            callCodeLabel: 'Ovozli xabardagi kodning 4 ta raqamini kiriting',
            smsCodeLabel: 'SMS da kelgan kod',
            placeholder: 'Kod yordamida SMS ni tasdiqlash',
            validation: {
              requiredCallCode: 'Ovozli xabardagi kodning 4 ta raqamini kiriting',
              requiredSmsCode: '5 ta belgidan iborat kodni kiriting',
              incorrectSmsCode: 'Noto‘g‘ri kod kiritdingiz',
              incorrectCallCode: 'Noto‘g‘ri kod kiritdingiz',
            },
          },
        },
        position: {
          placeholder: 'Lavozimni tanlang yoki yozing',
          name: 'Lavozim',
          validation: {
            required: 'Lavozimingizni yozing. Eng kamida - 3 ta belgi',
            min: 'Eng kamida - 3 ta belgi',
          },
        },
        organization: {
          name: 'Tashkilot',
          validation: {
            required: 'Tashkilot nomini yozing',
            minLength: 'Eng kamida - 3 ta belgi',
          },
        },
        staff: {
          validation: {
            required: "Sizning kompaniyangiz hajmini ko'rsatishingiz kerak",
          },
        },
        taxation: {
          validation: {
            required: "Taqdim etilgan ro'yxatdan soliq solish tizimini tanlang",
          },
        },
        birthDate: {
          placeholder: 'Tug‘ilgan kun sanasini kiriting',
          name: 'Tug‘ilgan kun sanasi',
          validation: {
            required: 'Tug‘ilgan kun sanasini kiritish shart',
            incorrect: 'Sana noto‘g‘ri kiritilgan',
          },
        },
        branch: {
          placeholder: 'Faoliyatingiz turini tanlang',
          name: 'Soha',
          validation: {
            incorrect: "Taqdim etilgan ro'yxatdan sanoatni tanlang",
          },
        },
        socialField: {
          name: 'Ijtimoiy tarmoqlar yordamida ro‘yxatdan o‘tish',
        },
        submitButton: {
          name: 'Ro‘yxatdan o‘tish',
          confirmation: {
            firstText: 'Нажимая на кнопку "Зарегистрироваться", вы принимаете условия',
            conditionalTitle: 'пользовательского соглашения.',
            secondText: '"Ro‘yxatdan o‘tish" tugmasini bosish bilan ',
            conditionalTitleUz: 'foydalanuvchi kelishuvi',
            thirdText: ' shartlarini qabul qilasiz.',
            eulaRefUz: 'https://id.mcfr.uz/Account/Agreement?lang=uz',
          },
        },
        logonButton: {
          name: 'Kirish',
          href: '/Logon',
        },
        doYouHaveAccount: {
          name: 'Akkaunt bormi?',
        },
        serverErrors: {
          'Sms code is incorrect': 'Noto‘g‘ri kod kiritdingiz',
        },
        serverErrorMessage: {
          header: 'Server xatosi',
          description: 'Bir necha daqiqadan so‘ng qayta urinib ko‘ring',
        },
      },
      successForm: {
        title: 'Hammasi yaxshi amalga oshdi, endi siz biz bilansiz!',
        titleError: 'Xatolik yuz berdi',
        descriptionUz: 'Pochtani tasdiqlashingiz lozim. Biz havolani',
        descriptionErrorUz: ' manziliga havola yuborib bo‘lmayapti. Joriy sahifadan so‘rovni qayta yuboring.',
        descriptionUzAdditional: 'manziliga yubordik.',
        description2: 'Agar elektron pochtada xabarni ko‘rmasangiz, xatlar ro‘yxatini yoki spamni tekshiring.',
        description2Error: 'Yoki istalgan vaqtda mahsulotlarga kirish sahifasidan foydalaning.',
        sendAgain: 'Qayta yuboring',
        sendAgainTimer: 'dan so‘ng qayta yuboring',
        login: 'Mahsulotlarga kirishga o‘ting',
      },
    },
    outdatedLink: {
      button: {
        href: '/Logon',
      },
    },
  },
}
